import React, { useEffect, useState } from 'react';
import { Switch } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { selectEditUtilitiesRows, selectIsEditMod } from 'store/redux-store/placement-mods/selectors';
import { GridCellParams } from '@mui/x-data-grid';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { Controller, useFormContext } from 'react-hook-form';
import { furnitureModStyles } from '../FurnitureMod.styles';
import { getExistingRow, getNewRow } from './IncludeEdit';

interface GridCellProps {
  [key: string]: any;
}

export const BillableCell = (cellParams: GridCellParams) => {
  return <Billable cellParams={cellParams} />;
};

const Billable = React.memo(function Billable(cellParams: GridCellProps) {
  const dispatch = useDispatch();
  const [isBillable, setIsBillable] = useState(cellParams?.cellParams?.row?.billable);
  const isModEdit = useSelector(selectIsEditMod);

  const utilityEditRequests = useSelector(selectEditUtilitiesRows);
  const { control } = useFormContext();
  const RowId = cellParams?.cellParams?.id;

  const { classes } = furnitureModStyles({ isExpanded: false });

  const onClickHandler = () => {
    let newRow = utilityEditRequests.slice(0);
    let EditRow = cellParams?.cellParams?.row?.placementUtilityId
      ? getExistingRow(utilityEditRequests, cellParams, true)
      : getNewRow(utilityEditRequests, RowId);

    let updatedRow = { ...EditRow, billable: !isBillable };
    let editDescriptionIndex = utilityEditRequests?.findIndex(
      cellParams?.cellParams?.row?.placementUtilityId
        ? row => row.placementUtilityId === updatedRow.placementUtilityId
        : row => row.id === RowId,
    );

    newRow[editDescriptionIndex] = updatedRow;
    dispatch(placementModsAction.setEditUtilitiesRows(newRow));

    setIsBillable(!isBillable);
  };

  useEffect(() => {
    if (!cellParams?.cellParams?.row?.include) {
      setIsBillable(false);
    }
  }, [cellParams?.cellParams?.row?.include]);

  return (
    <>
      <Controller
        name={`utilityRequests${RowId}.billable`}
        control={control}
        render={({ field: { onChange, onBlur, value, ...rest } }) => (
          <>
            <Switch
              disabled={!cellParams?.cellParams?.row?.include}
              checked={isBillable}
              className={isModEdit ? classes.switchPrimary : classes.switchLightBlue}
              onClick={() => {
                onClickHandler();
                onChange(!isBillable);
              }}
              onBlur={onBlur}
            />{' '}
            {isBillable ? 'Yes' : 'No'}
          </>
        )}
      />
    </>
  );
});
